import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "47",
  height: "57",
  viewBox: "0 0 47 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22.5",
      cy: "6.5",
      r: "5.5",
      fill: "#25262A"
    }, null, -1),
    _createElementVNode("path", {
      d: "M33.441 17.434c-1.097-1.097-2.981-3.122-6.638-3.122H19.66C11.925 14.284 5.625 7.984 5.625.249H0c0 8.888 5.934 16.425 14.063 18.872V56.5h5.625V39.624h5.625V56.5h5.625V22.89L42.048 34l3.965-3.966-12.572-12.6Z",
      fill: "#25262A"
    }, null, -1)
  ]))]))
}
export default { render: render }